import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, ApiError } from "@/api/client";
import { useAuth } from "@/hooks/useAuth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refreshProfile } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = "Anmeldung … – Englputzeder Tippspiel";
    const token = params.get("token");
    const errParam = params.get("error_description") ?? params.get("error");
    if (errParam) {
      setError(errParam);
      return;
    }
    if (!token) {
      setError("Anmeldung konnte nicht abgeschlossen werden.");
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const r = await api.auth.verifyMagic(token);
        if (cancelled) return;
        await refreshProfile();
        let redirect = r.redirect ?? "/";
        try {
          const code = sessionStorage.getItem("pending_invite_code");
          if (code) redirect = `/?code=${code}`;
        } catch {
          /* ignore */
        }
        navigate(redirect, { replace: true });
      } catch (err) {
        if (cancelled) return;
        setError(err instanceof ApiError ? err.message : "Anmeldung fehlgeschlagen");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate, params, refreshProfile]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="text-center max-w-md">
        {!error ? (
          <>
            <div className="font-display text-3xl mb-2 animate-pulse">⚽ Anmeldung läuft …</div>
            <p className="text-muted-foreground">Du wirst gleich weitergeleitet.</p>
          </>
        ) : (
          <>
            <div className="font-display text-2xl mb-2">Hoppla 😕</div>
            <p className="text-muted-foreground mb-4">{error}</p>
            <a href="/login" className="underline font-medium">
              Neuen Link anfordern
            </a>
          </>
        )}
      </div>
    </div>
  );
}
